




























































































import { Component, Vue } from 'vue-property-decorator';
import * as api from '@/api';
import { TrainingScheduling } from '@/api/models';
import moment from 'moment';
import { Dialog } from 'vant';
@Component({})
export default class ScheduleIndex extends Vue {
  trainingSchedulings: TrainingScheduling[] = [];
  backgroundDiv = {
    backgroundImage: 'url(' + require('@/images/halfButton.png') + ')',
    backgroundRepeat: 'no-repeat',
    backgroundSize: '40px 20px',
    width: '40px',
    textAlign: 'center',
    lineHeight: '20px',
    color: 'white',
    marginTop: '2px',
  };
  trainingTime: any = null;
  mounted() {
    if (this.$route.params.trainingSchedulings) {
      this.trainingSchedulings = JSON.parse(this.$route.params.trainingSchedulings);
    } else {
      this.$router.push({
        name: 'home',
      });
    }
  }

  getTrainingTime(item: any) {
    let trainingDate = moment(item.trainingDate).format('YYYY-MM-DD');
    let trainingStartTime = moment(item.trainingStartTime).format('HH:mm:ss');
    let trainingEndTime = moment(item.trainingEndTime).format('HH:mm:ss');
    let trainingTime = trainingDate + ' ' + trainingStartTime + '-' + trainingEndTime;
    return trainingTime;
  }

  // halfButton: string = require('@/images/halfButton.png');
  onClickLeft() {
    this.$router.back();
  }
  toTeacherEvaluation(item: any) {
    let trainingStartTime = new Date(item.trainingStartTime);
    let dateTimeNow = new Date();
    if (trainingStartTime < dateTimeNow) {
      this.$router.push({
        name: 'feedback',
        params: { feedbackTitle: '评价教师', teacherDetail: item },
      });
    } else {
      Dialog.alert({
        message: '当前课程还未开始，不能评价！',
      });
    }
  }
}
